import { consola } from 'consola'
import { useSessionManager } from '~/entities/auth/model'
import { useTokenRefreshV2 } from '~/features/auth/model'

// Logger
const logger = consola.withTag('token-background-refresh-plugin')

/**
 * Плагин для автоматического запуска фонового обновления токена
 * 
 * ✅ Запускается автоматически при загрузке приложения
 * ✅ Проверяет токен каждые 30 секунд
 * ✅ Обновляет токен за 1 минуту до истечения (проактивно)
 * ✅ Останавливается при разлогине
 * ✅ Предотвращает 401 ошибки благодаря проактивному обновлению
 * 
 * @see composables/useTokenRefreshV2.ts
 */
export default defineNuxtPlugin((_nuxtApp) => {
  if (!process.client) return

  logger.info('🔌 Инициализация плагина фонового обновления токена')

  const tokenRefreshV2 = useTokenRefreshV2()
  const sessionManager = useSessionManager()

  // Запускаем фоновое обновление если есть активная сессия
  if (sessionManager.hasActiveSession.value) {
    logger.info('✅ Обнаружена активная сессия, запускаем фоновое обновление')
    tokenRefreshV2.startBackgroundRefresh()
  } else {
    logger.debug('❌ Активная сессия не найдена, фоновое обновление не запущено')
  }

  // Следим за изменением состояния сессии
  watch(sessionManager.hasActiveSession, (hasSession) => {
    if (hasSession) {
      logger.info('✅ Сессия появилась, запускаем фоновое обновление')
      tokenRefreshV2.startBackgroundRefresh()
    } else {
      logger.info('❌ Сессия завершена, останавливаем фоновое обновление')
      tokenRefreshV2.stopBackgroundRefresh()
    }
  })

  // Останавливаем таймер при закрытии приложения
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      logger.debug('🛑 Приложение закрывается, останавливаем фоновое обновление')
      tokenRefreshV2.stopBackgroundRefresh()
    })
  }

  logger.success('✅ Плагин фонового обновления токена инициализирован')
})

